import { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { mdlHotelRoomType } from "../../../models/domain/HotelRoomType";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import SortableList, { SortableItem } from "react-easy-sort";
import { useMutation } from "react-query";
import { mdlHotelRoomTypePrioritySortRequest } from "../../../models/service-models/hotel/HotelRoomTypePrioritySortRequest";
import { DefinitionService } from "../../../services/DefinitionService";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import _ from "lodash";
import { arrayMove } from "@dnd-kit/sortable";

export type RoomPriortySorterProps = {
    selectedHotel?:string;
    data?: mdlHotelRoomType[];
    fnModalClose?: Function;
}

export const RoomPriortySorter = (props: RoomPriortySorterProps) => {
    const { t } = useTranslation();
    const [items, setItems] = useState<mdlHotelRoomType[]>();
    
    useEffect(() => {
        if (!items)
            setItems(props.data);

    }, [props]);
    
    const closeModal = () => {
        props.fnModalClose && props.fnModalClose();
    }

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        if(!items){
            return;
        }
        let newItems =  _.cloneDeep(items)
        newItems = arrayMove(newItems, oldIndex, newIndex);
        setItems(newItems);
    };

    const { mutateAsync: saveRoomTypePrioritySort, isLoading: mutateLoadingRoomTypeDelete, data: mutateDataRoomTypeDelete } = useMutation(
        (request: mdlHotelRoomTypePrioritySortRequest) => DefinitionService.RoomTypePrioritySort(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                    props.fnModalClose && props.fnModalClose();
                }else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );
    
    const fnSave = () => {
        saveRoomTypePrioritySort({roomTypeIds:items?.map(x=> x.id)} as mdlHotelRoomTypePrioritySortRequest);
    }
    return (
        <>
        <div className="row">
            {
                !props.data
                &&
                <div className="col-sm-12">
                    <div className="alert alert-warning alert-icon">
                        <FontAwesomeIcon icon={ faWarning } />
                        <span className="ps-4">{t('definitions.hotels.mustChooseItems')}</span>
                    </div>
                </div>
            }
            {
                props.data
                &&
                <>
                    <div className="col-md-12 mt-4 ">
                        <SortableList
                        color="red"
                        onSortEnd={onSortEnd}
                        className="nk-data data-list"
                        draggedItemClassName="dragged"
                        >
                        {items?.map((item) => (
                            
                            <SortableItem key={item.id}>
                                <div className="data-item draggable-item">{item.name}</div>
                            </SortableItem>
                        ))}
                        </SortableList>
                    </div>
                </>
            }
                <div className="col-md-12 mt-4 text-end ">
                    {
                    props.data
                    &&
                        <Button className="btn btn-secondary btn-dim me-2 " onClick={fnSave} >{t("common.save")}</Button>
                    }
                    <Button className="btn btn-danger btn-dim me-2 " onClick={closeModal}>{t("common.close")}</Button>
                </div>
        </div>
        </>
    )
}